import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
const Detail = lazy(() => import('./components/Detail'))

const Home = lazy(() => import('./components/Home'))
const PasswordSecurity = lazy(
    () => import('./components/Detail/PasswordSecurity')
)
const Contracts = lazy(() => import('./components/Detail/Contracts'))
const WorkingProcess = lazy(() => import('./components/Detail/WorkingProcess'))
const MyIncomes = lazy(() => import('./components/MyIncomes'))
const MyRatings = lazy(() => import('./components/MyRatings'))
const CustomerEvents = lazy(() => import('./components/CustomerEvents'))
const Regulations = lazy(() => import('./components/Detail/Regulations'))
const Oncall = lazy(() => import('./components/Oncall'))
const ReferralSummary = lazy(() => import('./components/ReferralSummary'))

const AccountModule: RouteObject = {
    path: 'account',
    children: [
        {
            path: '',
            element: <Home />,
        },
        {
            path: 'info',
            element: <Detail />,
        },
        {
            path: 'password-security',
            element: <PasswordSecurity />,
        },
        {
            path: 'contracts',
            element: <Contracts />,
        },
        {
            path: 'working-process',
            element: <WorkingProcess />,
        },
        {
            path: 'my-incomes',
            element: <MyIncomes />,
        },
        {
            path: 'my-ratings',
            element: <MyRatings />,
        },
        {
            path: 'customer-events',
            element: <CustomerEvents />,
        },
        {
            path: 'regulations',
            element: <Regulations />,
        },
        {
            path: 'oncall',
            element: <Oncall />,
        },
        {
            path: 'referral',
            element: <ReferralSummary />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AccountModule
